export default __webpack_public_path__ + "static/media/featSport.881d7fed.png";